import { HttpClient, provideHttpClient, withFetch } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, inject, isDevMode, provideExperimentalZonelessChangeDetection } from '@angular/core';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, provideRouter, RouterStateSnapshot, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CustomMissingTranslationHandler, TranslationHttpLoader } from 'src/utils/missing-translation-handler';
import { CatalogContentAndSearchResolver, ContentResolver, InitialContentResolver, RouteConfig, UnknownContentResolver } from './app.routes';


export const config = {
  translate: {
    loader: {
      provide: TranslateLoader,
      useFactory: (http: HttpClient) => TranslationHttpLoader(http),
      deps: [HttpClient]
    },
    missingTranslationHandler: {
      provide: MissingTranslationHandler,
      useClass: CustomMissingTranslationHandler
    },
    defaultLanguage: 'da-dk',
    useDefaultLang: true
  },

};
export const appConfig: ApplicationConfig = {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    provideRouter(
      RouteConfig.routes(),
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })
    ),
    provideHttpClient(withFetch()),
    provideClientHydration(withEventReplay()),
    provideServiceWorker('ngsw.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWithDelay:5000',
      scope: '',
    }),
    importProvidersFrom(
      TranslateModule.forRoot(config.translate)
    )
  ],
};
